import { exists } from '../base/dom-utils.js';
import Analytics from '../base/wyn-analytics-module.js';

class PromoDeals {
  constructor() {
    if (exists('.promodeals-component')) {
      this.bindEvents();
    }
  }

  bindEvents() {
    $('.promo-info-container a').click((e) => {
      Analytics.getPromoDealsInfo(this);
      //"dynamicoffershownClick" Event Activation Point - Push Adobe Digital Data onclick of Dynamic offer content link on Search Result page.
      window.AdobeWebSdk && window.AdobeWebSdk.onClickDynamicOfferContentSRPPage(e.target);
    });
  }
}

export default new PromoDeals();
